interface MenuItem {
    headTitle1?: string;
    headTitle2?: string;
    title?: string;
    icon?: string;
    icon1?: string;
    type: string;
    badgeType?: string;
    active?: boolean;
    isPinned?: boolean;
    path?: string;
    children?: MenuItem[];
    bookmark?: boolean;
}

export const menu: MenuItem[] = [
    {
        headTitle1: "ระบบ",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle",
    },
    {
        title: "ระบบคลังสินค้า",
        icon: "stroke-ecommerce",
        icon1: "fill-ecommerce",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/receipt/add_product_receipt",
                title: "เพิ่มสินค้านำเข้า",
                type: "link",
            },
            {
                path: "/receipt/list_stock",
                title: "คลังสินค้าขาย",
                type: "link",
            },
            {
                path: "/receipt/list_stock_defective",
                title: "อุปกรณ์ชำรุด",
                type: "link",
            },
            {
                path: "/receipt/list_stock_back_up",
                title: "อุปกรณ์สำรอง / อะไหล่สำรอง",
                type: "link",
            },
            {
                path: "/receipt/list_stock_demo",
                title: "เครื่อง Demo",
                type: "link",
            }
        ],
    },
    {
        title: "ระบบแพลนสินค้า",
        icon: "stroke-ecommerce",
        icon1: "fill-ecommerce",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/receipt/list_product",
                title: "สินค้าคงคลัง",
                type: "link",
            },
            {
                path: "/receipt/product_planner_list",
                title: "แพลนสินค้า",
                type: "link",
            },
        ],
    },
    {
        title: "ระบบจัดส่งสินค้า/ติดตั้ง",
        icon: "stroke-board",
        icon1: "fill-board",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            {
                path: "/receipt/list_preparation",
                title: "รายการจัดส่งสินค้า",
                type: "link",
            },
            {
                path: "/receipt/list_shipping",
                title: "รายการติดตั้ง",
                type: "link",
            }
        ],
    },
    // {
    //     headTitle1: "ระบบแจ้งซ่อม",
    //     headTitle2: "Dashboards,Widgets & Layout.",
    //     type: "headtitle",
    // },
    // {
    //     title: "ระบบแจ้งซ่อม",
    //     icon: "stroke-board",
    //     icon1: "fill-board",
    //     type: "sub",
    //     active: false,
    //     isPinned: false,
    //     children: [
    //         {
    //             path: "/repair_request/list_repair_request",
    //             title: "รายการซ่อม",
    //             type: "link",
    //         }
    //     ],
    // },
    // {
    //     headTitle1: "ระบบค่าบริการรายปี",
    //     headTitle2: "Dashboards,Widgets & Layout.",
    //     type: "headtitle",
    // },
    // {
    //     title: "ค่าบริการรายปี",
    //     icon: "stroke-ecommerce",
    //     icon1: "fill-ecommerce",
    //     type: "sub",
    //     active: false,
    //     isPinned: false,
    //     children: [
    //         {
    //             path: "/annual_service_fee/add_service_fee",
    //             title: "เพิ่มค่าบริการรายปี",
    //             type: "link",
    //         },
    //         {
    //             path: "/annual_service_fee/service_fee_list",
    //             title: "รายชื่อร้านบริการรายปี",
    //             type: "link",
    //         },
    //         {
    //             path: "/annual_service_fee/clouds_list",
    //             title: "รายชื่อคลาวด์",
    //             type: "link",
    //         },
    //     ],
    // },
    {
        headTitle1: "ระบบบริการบำรุงรักษา",
        headTitle2: "Dashboards,Widgets & Layout.",
        type: "headtitle",
    },
    {
        title: "MA",
        icon: "stroke-board",
        icon1: "fill-ecommerce",
        type: "sub",
        active: false,
        isPinned: false,
        children: [
            // {
            //     path: "/annual_service_fee/add_service_fee",
            //     title: "ติดตามใบ MA",
            //     type: "link",
            // },
            // {
            //     path: "/ma/create_ma",
            //     title: "สร้างใบ MA",
            //     type: "link",
            // },
            {
                path: "/ma/list_ma/passed",
                title: "รายการ MA ที่สำเร็จ",
                type: "link",
            },
            {
                path: "/ma/list_ma/waiting",
                title: "รายการ MA ที่ยังไม่สำเร็จ",
                type: "link",
            },
            {
                path: "/ma/equipments",
                title: "รายชื่ออุปกรณ์",
                type: "link",
            }
        ],
    },
];
